import { css, useTheme } from "@emotion/react";
import { Field as DefaultField } from "formik";

import {
  useThemeProps,
  handleComponentsProp,
  ToggleButtonGroup,
  MaybeFragment,
} from "../../wsui/base";

import DefaultFormFieldDescription from "./FormFieldDescription.jsx";
import DefaultFormFieldError from "./FormFieldError.jsx";
import DefaultFormFieldLabel from "./FormFieldLabel.jsx";
import DefaultFormFieldWrapper from "./FormFieldWrapper.jsx";

export default function FormToggleButtonGroupField(props) {
  props = useThemeProps({ props, name: "FormToggleButtonGroupField" });
  props = useThemeProps({ props, name: "FormField" });
  let {
    inputProps = {},
    buttonProps = {},
    placeholder,
    components,
    rowGap = [1, 2],
    options,
    ...restProps
  } = props;
  let {
    Field,
    FormFieldDescription,
    FormFieldError,
    FormFieldLabel,
    FormFieldWrapper,
  } = handleComponentsProp(components, {
    Field: DefaultField,
    FormFieldDescription: DefaultFormFieldDescription,
    FormFieldError: DefaultFormFieldError,
    FormFieldLabel: DefaultFormFieldLabel,
    FormFieldWrapper: DefaultFormFieldWrapper,
  });
  const theme = useTheme();

  let { ...restInputProps } = inputProps;

  return (
    <FormFieldWrapper
      // className={clsx(styles.component, className)}
      css={css`
        display: grid;
        grid-template-columns: 1fr;
        grid-row-gap: ${theme.getLength(rowGap)};
      `}
      {...restProps}
    >
      {({
        name,
        controlProps,
        wrapperProps,
        type,
        id,
        multiple,
        inputProps,
      }) => (
        <MaybeFragment {...wrapperProps}>
          <FormFieldLabel
          // className={styles.label}
          />
          <FormFieldDescription
          // className={styles.description}
          />
          <div
          // className={styles.control}
          >
            <Field
              as={ToggleButtonGroup}
              type={type}
              // className={styles.input}
              name={name}
              id={id}
              placeholder={placeholder}
              options={options}
              multiple={multiple}
              {...controlProps}
              {...inputProps}
              {...restInputProps}
              buttonProps={buttonProps}
            />
          </div>
          <FormFieldError
          // className={styles.error}
          />
        </MaybeFragment>
      )}
    </FormFieldWrapper>
  );
}
